import script from "./PopOver2.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopOver2.vue?vue&type=script&setup=true&lang=ts"

import "./PopOver2.vue?vue&type=style&index=0&id=0e21b1f6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3760926026/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e21b1f6"]])

export default __exports__